import React from "react";
import { Box, Typography, TextField } from "@mui/material";

const CustomTextField = ({ label, value, onChange, width }) => {
  return (
    <Box
      sx={{
        margin: "20px 0",
        bgcolor: "rgb(239, 253, 255, 0.9)",
        padding: "20px",
        borderRadius: 4,
        border: "2px solid #00999E",
        background: `linear-gradient(to right, 
              rgba(167, 214, 215, 0.6) 10%,   
              rgba(218, 240, 241, 0.5) 60%, 
              rgba(255, 255, 255, 1) 100%)`,
        display: "flex",
        justifyContent: "space-between",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: { sm: "600px", xs: "300px" },
          margin: "auto",
          display: "flex",
          flexDirection: "row",
          textAlign: { xs: "center", md: "start" },
        }}
      >
        <Typography variant="h6" gutterBottom>
          {label} <span style={{color:'red', fontSize:20}}>*</span>
        </Typography>
        
      </Box>

      <Box sx={{ width: { sm: "600px", xs: "300px" } }}>
        <TextField
          fullWidth
          value={value}
          onChange={onChange}
          placeholder="Enter text..."
          sx={{
            width: width ?? "100%",
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              backgroundColor: "white",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#00999E",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#007B7E",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#00999E",
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default CustomTextField;
